export default __webpack_public_path__ + "static/media/er2.df49e426.png";